import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import SortOption from '~/constants/common/SortOption';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';

const useGetSortByChanged = () => {
  const { sortBy } = useContext(AppliedFiltersContext);
  const isInitialSortBy = useRef(true);

  useEffectOnce(
    () => {
      isInitialSortBy.current = false;
    },
    [],
    sortBy !== SortOption.MostPopular
  );

  return isInitialSortBy.current;
};

export default useGetSortByChanged;
